import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import CourseCatalog from './components/CourseCatalog';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <CourseCatalog />
        <Features />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}